import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import Vue from "vue";
import * as Data from "@/data";
Vue.mixin({
  data: function data() {
    return {
      userId: null,
      isAdmin: false,
      isManager: false,
      userName: null,
      isMHDCAdmin: false
    };
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.userId = Data.Authentication.GetUserId();
              this.isAdmin = Data.Authentication.IsMHDCAdmin();
              this.isManager = Data.Authentication.GetIsManager();
              this.userName = Data.Authentication.GetUserName();
              this.isMHDCAdmin = Data.Authentication.IsMHDCSystemAdmin();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }()
});